<template>
  <button
    class="
      tw-text-secondary
      tw-cursor-pointer
      tw-select-none
      tw-font-medium
      tw-inline-block
    "
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {}
</script>

<style></style>
